/**
 * Runs a fire-and-forget tracking call off the interaction's critical path. `sendGAEvent` pushes to
 * `window.dataLayer` synchronously, which triggers GTM tag execution during the same interaction and
 * extends its processing time (an INP hazard). Deferring the push lets the interaction paint first.
 *
 * Uses `requestIdleCallback` where available, falling back to a `setTimeout`. Only use this for tracking
 * that does not need to complete before navigation (e.g. impressions, carousel navigation) — never for
 * link-click tracking that must run synchronously to record before the browser navigates away. For that
 * case use `sendGALinkClickEvent`, which awaits the event before navigating.
 */
export const deferTracking = (callback: () => void): void => {
  if (typeof window === 'undefined') {
    callback();
    return;
  }

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => callback(), { timeout: 500 });
    return;
  }

  window.setTimeout(callback, 0);
};
